import { IGameState } from 'State/Game/IGameState';
import CardStateHelper, { getCardsState } from '../CardStateHelper';
import { ICardsState } from '../ICardState';
import BaseModifierBehavior from './BaseModifierBehavior';
import { CardTask } from '../CardTasks';

export default class ConnectedModifierBehavior extends BaseModifierBehavior {
    public isBlocking(cardsState: ICardsState): boolean {
        const connectedCardBehavior = CardStateHelper.getCardBehavior(cardsState, this.modifier.properties.cardID);
        return connectedCardBehavior.isObscured(cardsState);
    }

    public overrideCardPlay(state: ICardsState): boolean {
        return true;
    }

    public play(oldState: IGameState): IGameState {
        let state = { ...oldState };
        const cardIDs = [this.cardID, this.modifier.properties.cardID];
        cardIDs.forEach((cardID, index) => {
            const behavior = CardStateHelper.getCardBehavior(state.levelState.cardsState, cardID);
            state = behavior.collectCard(state, {
                forceClearUndoHistory: true,
                rewardCoins: true,
                queueMatchTask: false,
                updateModifiers: index === 0,
            });
        });

        let cardsState = getCardsState(state);

        cardsState = CardStateHelper.setStateTaskData(cardsState, {
            task: CardTask.MATCH_CONNECTED_CARD,
            cards: cardIDs,
        });

        state = CardStateHelper.updateGameState(state, cardsState);

        return state;
    }

    // TODO: Verify if this is working as intended and cleanup other cases of removing connected cards via boosters or other means
    /**
     * Check on update if connected card should be collected and collect itself if so
     * @param state
     */
    /* public update(state: IGameState): IGameState {
        const cardState = CardStateHelper.getCardState(state, this.cardID);
        const connectedCardState = CardStateHelper.getCardState(state, this.modifier.properties.cardID);

        if (cardState === CardState.IN_PLAY && connectedCardState !== CardState.IN_PLAY) {
            const behavior = CardStateHelper.getCardBehavior(state.levelState.cardsState, this.cardID);
            state = behavior.collectCard(state, {
                forceClearUndoHistory: true,
                rewardCoins: true,
                queueMatchTask: false,
                updateModifiers: false,
                newCardState: connectedCardState,
            });
        }

        return state;
    } */

    public fillFlipDelays(cardsState: ICardsState, delayByCardID: Record<string, number>): void {
        const behavior = CardStateHelper.getCardBehavior(cardsState, this.modifier.properties.cardID);

        cardsState.inPlay.forEach(cardID => {
            if (behavior.isOverlapping(cardsState, cardID)) {
                delayByCardID[cardID] = Math.max(delayByCardID[cardID] ?? 0, 1000);
            }
        });
    }
}
